module.exports = __webpack_public_path__ + "static/bg-2823c37cb9bffcc5b4834963c131c24e.jpg";